import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseIcon, SearchIcon } from '../../icons';

interface ISearchProps {
  onChange: (value: string) => any;
  initialValue?: string;
  className?: string;
  clearButton?: boolean;
}

export const Search: React.FC<ISearchProps> = ({
  onChange,
  initialValue = '',
  className = '',
  clearButton,
}: ISearchProps) => {
  const [search, setSearch] = useState(initialValue);
  const { t } = useTranslation();

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      onChange(search);
    }
  };

  const handleChange = (e: any) => {
    setSearch(e.target.value);
  };

  return (
    <div className={`search-input d-flex align-items-center ${className}`}>
      <div className="input-group">
        <input
          className="form-control"
          name="search"
          placeholder={t('search')}
          value={search}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />

        <div className="input-group-append" id="button-addon4">
          <button
            type="button"
            className="btn btn-link p-0 mr-30 shadow-none"
            onClick={() => onChange(search)}
          >
            <SearchIcon />
          </button>
          {clearButton && search !== '' && (
            <button
              className="btn btn-link p-0 shadow-none"
              type="button"
              id="button-addon2"
              onClick={() => {
                setSearch('');
                onChange('');
              }}
            >
              <CloseIcon color="#2E323B" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

Search.defaultProps = {
  initialValue: '',
  className: '',
  clearButton: false,
};
